import { RECORDING_OPTIONS, BROADCAST_TEXT } from '../constants';

const getRecordingLiveText = (
	selectedRecordingOption: number,
	isStoppingRecording: boolean,
	stateMessage: string,
) => {
	switch (selectedRecordingOption) {
		case RECORDING_OPTIONS.RECORD:
			return isStoppingRecording ? 'record' : 'recording';
		default:
			if (stateMessage === BROADCAST_TEXT.LIVE) {
				return isStoppingRecording ? 'stream' : 'streaming';
			}
			return 'stream';
	}
};

export default getRecordingLiveText;
